import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { CountyService } from '../../../services/CountyService';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ConstantService } from '../../../services/ConstantService';
import { GetCountyListPagingAndFilterResponse, GetCountyListPagingAndFilterResponseData, GetCountyListPagingAndFilterResponseItem, initialGetCountyListPagingAndFilterResponseData } from '../../../models/response/county/GetCountyListPagingAndFilterResponse';
import { initialGetCountryListPagingAndFilterResponseData } from '../../../models/response/country/GetCountryListPagingAndFilterResponse';
import { GetCountyListPagingAndFilterRequest, initialGetCountyListPagingAndFilterRequest } from '../../../models/request/county/GetCountyListPagingAndFilterRequest';
import CountyListFilters from './Components/CountyListFilters';
import { DeleteCountyResponse } from '../../../models/response/county/DeleteCountyResponse';
import { ExportCountyListResponse } from '../../../models/response/county/ExportCountyListResponse';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { CountryService } from '../../../services/CountryService';

const CountyList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Genel Tanımlamalar > Şehir Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetCountyListPagingAndFilterResponseData>(initialGetCountyListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetCountyListPagingAndFilterRequest>(initialGetCountyListPagingAndFilterRequest);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Kodu', name: 'code', order: 0, isVisible: true },
            { title: 'Adı', name: 'name', order: 0, isVisible: true },
            { title: 'Ülkesi', name: 'countryName', order: 0, isVisible: true },
            { title: 'Eyalet Kodu', name: 'stateCode', order: 0, isVisible: true },
            { title: 'Bölgesi', name: 'regionName', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteCounty = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.countyId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteCountyResponse = await ConstantService.deleteConstant(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message);

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateCounty = async (_id: string | undefined = undefined) => {
        navigate('/county/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].countyId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetCountyListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var response: GetCountyListPagingAndFilterResponse = await CountyService.getCountyListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.countyId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportCountyListResponse = await CountyService.exportCountyList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.countyId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Bölge adı, bölge kimliği metin
    // alanda tutulup bellekte eşleştirildiği için listede yok; oluşturan ve
    // güncelleyen bilgisi de bellekte hazırlanıyor.
    // Sehir listesi cok buyuk oldugu icin yalnizca kaydin kendi kolonlarina gore
    // siralanir; ulke adina gore siralama olculdu ve ~6 saniye surdugu icin eklenmedi.
    const sortableColumns = ['code', 'name', 'stateCode'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (ConstantManager.ApplyColumnFilters, COUNTY) aynı.
    // Şehir ve ilçe tabloları çok büyük olduğu için ülke ve bölge dışında seçim listesi yok.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        code: { type: 'text' },
        name: { type: 'text' },
        countryName: { type: 'select', loadOptions: () => loadList(CountryService.getCountryList(), 'countryId', x => x.name) },
        stateCode: { type: 'text' },
        regionName: { type: 'select', loadOptions: () => loadConstants('COUNTY_REGION') },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetCountyListPagingAndFilterResponseItem, column: string, index: number) => {
        if (column == "createdUser") {
            return (
                <td onClick={() => setItemSelected(item.countyId)} onDoubleClick={() => updateCounty(item.countyId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td onClick={() => setItemSelected(item.countyId)} onDoubleClick={() => updateCounty(item.countyId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td onClick={() => setItemSelected(item.countyId)} onDoubleClick={() => updateCounty(item.countyId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <CountyListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteCounty}
                    updateFunction={updateCounty}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.countyId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default CountyList;